import { useFees, pct, money } from "@/hooks/useFees";
import { Tag, Radio } from "lucide-react";
import { FEEBAR } from "@/constants/testIds";

// Thin announcement bar at the very top of the site showing the live
// seller/marketplace fees pulled from print-shop-125.
export const FeeBar = () => {
  const { fees } = useFees();
  const listing = fees.listing_fee === 0 ? "$0 listing" : `${money(fees.listing_fee)} listing`;

  return (
    <div
      data-testid={FEEBAR.root}
      className="relative z-[60] border-b border-[rgba(0,229,255,0.25)] bg-gradient-to-r from-[rgba(0,229,255,0.12)] via-[rgba(18,20,27,0.6)] to-[rgba(212,0,255,0.12)]"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-2 text-center sm:px-6">
        <span className="inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-neo-cyan">
          <Tag className="h-3.5 w-3.5" /> Seller fees
        </span>
        <span data-testid={FEEBAR.summary} className="font-mono text-[11px] text-foreground">
          <strong className="font-semibold">{pct(fees.transaction_rate)}</strong> transaction
          <span className="mx-1.5 text-muted-foreground">+</span>
          <strong className="font-semibold">{pct(fees.processing_rate)} + {money(fees.processing_fixed)}</strong> processing
          <span className="mx-1.5 text-muted-foreground">&bull;</span>
          <strong className="font-semibold">{listing}</strong>
        </span>
        {fees.connected && (
          <span className="inline-flex items-center gap-1 rounded-full border border-[rgba(0,229,255,0.4)] bg-[rgba(0,229,255,0.1)] px-2 py-0.5 font-mono text-[9px] uppercase tracking-wider text-neo-cyan">
            <Radio className="h-2.5 w-2.5 animate-pulse" /> Live
          </span>
        )}
      </div>
    </div>
  );
};
